import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
const styles = (theme) => createStyles({
    tabContent: {
        width: '100%',
        height: 'calc(100% - 48px)',
    },
});
const TabContent = (props) => {
    const { classes, tabIndex, activeIndex, children, testId = 'TabContent' } = props;
    return tabIndex === activeIndex ? (React.createElement("div", { "data-testid": `${testId}`, className: classes.tabContent }, children)) : null;
};
const ComposedTabContent = compose(withStyles(styles, { withTheme: true }), pure)(TabContent);
ComposedTabContent.displayName = 'TabContent';
export default ComposedTabContent;
//# sourceMappingURL=TabContent.js.map